import React from 'react';
import TextField from '@material-ui/core/TextField';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react'; // Assuming you imported the icon lib like this

const SearchBar = ({ liveSearch, handleSearch }) => {
  return (
    <div id="searchBarDiv">
      <TextField
         id="searchBar"
         variant="outlined"
          label="Recherche"
         //placeholder="Recherche"
         className="smallText" size="small" margin='dense'
        InputProps={{
          startAdornment: (
            <Icon
               path={mdiMagnify}
               className="search-icon"
               size="25px"
               style={{ color: "action.active", mr: 1, my: 0.5 }}
               onClick={handleSearch}
            />
          ),
        }}
        onKeyUp={liveSearch}
      />
    </div>
  );
};

export default SearchBar;
